export interface SplitDiscountConfig {
  enabled?: boolean | null;
  percentage?: number | null;
  cap?: number | null;
}

export interface AppliedSplitDiscount {
  amount: number;
  percentage: number;
  cap: number | null;
  enabled: boolean;
}

export function getAppliedSplitDiscount(
  subtotal: number,
  config: SplitDiscountConfig | null | undefined,
): AppliedSplitDiscount {
  const enabled = Boolean(config?.enabled);
  const percentage = Number(config?.percentage || 0);
  const rawCap = config?.cap;
  const cap = rawCap === null || rawCap === undefined || Number(rawCap) <= 0 ? null : Number(rawCap);

  if (!enabled || subtotal <= 0 || percentage <= 0) {
    return {
      amount: 0,
      percentage,
      cap,
      enabled,
    };
  }

  const percentageAmount = Number(((subtotal * percentage) / 100).toFixed(2));
  const amount = cap === null ? percentageAmount : Math.min(percentageAmount, cap);

  return {
    amount: Number(amount.toFixed(2)),
    percentage,
    cap,
    enabled: true,
  };
}
